<template>
  <div class="app-manager-container">
    <!-- 卡片容器（带阴影、圆角） -->
    <el-card class="content-card" shadow="hover">
      <!-- 头部操作栏 -->
      <div class="header-operation">
        <div class="search-box">
          <el-input
            placeholder="输入软件ID/名称搜索"
            v-model="keyword"
            clearable
            style="width: 350px;"
            @keyup.enter="getAppList"
            size="medium"
          >
            <template #prefix>
              <i class="el-icon-search el-input__icon"></i>
            </template>
          </el-input>
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="openAddDialog"
          size="medium"
          class="add-btn"
        >
          新增软件
        </el-button>
      </div>

      <!-- 表格（美化样式+空数据提示） -->
      <el-table
        :data="appList"
        border
        stripe
        style="width: 100%; margin-top: 20px;"
        @row-dblclick="handleRowDblClick"
        :header-cell-style="{ background: '#f5f7fa', fontWeight: 'bold', color: '#303133' }"
        :cell-style="{ padding: '12px 0' }"
        empty-text="暂无软件数据，请先新增"
        size="medium"
      >
        <el-table-column prop="appId" label="软件ID" align="center" width="200">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.appId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appName" label="软件名称" align="center" width="200">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.appName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="软件备注" align="center" min-width="300">
          <template #default="scope">
            <span class="cell-text">{{ scope.row.description || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="scope">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click.stop="handleEdit(scope.row)"
              class="edit-btn"
            >编辑</el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click.stop="deleteApp(scope.row.id)"
              class="delete-btn"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗（圆角+美化） -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync=" dialogVisible" 
      width="550px"
      close-on-click-modal="false"
      :close-on-press-escape="false"
      border-radius="12px"
  
    >
      <el-form
        :model="formData"
        label-width="100px"
        ref="appFormRef"
        :rules="formRules"
        label-position="right"
        class="dialog-form"
      >
        <el-form-item label="软件ID" prop="appId">
          <el-input
            v-model="formData.appId"
            :disabled="isEdit"
            size="medium"
            placeholder="请输入唯一软件ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="软件名称" prop="appName">
          <el-input
            v-model="formData.appName"
            size="medium"
            placeholder="请输入软件名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="软件备注" prop="description">
          <el-input
            type="textarea"
            v-model="formData.description"
            rows="4"
            size="medium"
            placeholder="请输入软件备注（可选）"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="medium" @click="submitForm">确认提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AppManager',
  data() {
    return {
      appList: [],
      keyword: '',
      dialogVisible: false,
      dialogTitle: '新增软件',
      isEdit: false,
      formData: {
        id: '',
        appId: '',
        appName: '',
        description: ''
      },
      formRules: {
        appId: [
          { required: true, message: '请输入软件ID', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符之间', trigger: 'blur' }
        ],
        appName: [
          { required: true, message: '请输入软件名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符之间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // 初始化加载列表
    this.getAppList()
  },
  methods: {
    /**
     * 获取软件列表（已修正 GET 请求参数格式）
     */
    getAppList() {
      const params = {
        keyword: this.keyword || ''
      }
      
      // 修正：GET 请求参数放入 { params } 中，适配 axios 规范
      this.request.get("/api/app/list", { params }).then(res => {
        if (res.code === '0' || res.code === 200) {
          this.appList = res.data || []
        } else {
          this.$message.error(res.msg || res.message || '获取列表失败')
        }
      }).catch(err => {
        this.$message.error('网络请求失败，请检查后端服务')
        console.error(err)
      })
    },

    /**
     * 打开新增弹窗
     */
    openAddDialog() {
      console.log("xin新增")
     this.dialogTitle = '新增软件'
     this.isEdit = false
     this.resetForm()
      this.dialogVisible = true
    },

    /**
     * 处理行双击事件
     */
    handleRowDblClick(row, column, event) {
      this.handleEdit(row)
    },
    
    /**
     * 处理编辑按钮点击
     */
    handleEdit(row) {
      this.openEditDialog(row)
    },

    /**
     * 打开编辑弹窗
     */
    openEditDialog(row) {
      this.dialogTitle = '编辑软件'
      this.isEdit = true
      // 深拷贝行数据，避免直接修改表格数据
      this.formData = { ...row }
      this.dialogVisible = true
      
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.appFormRef) {
          this.$refs.appFormRef.clearValidate()
        }
      })
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formData = {
        id: '',
        appId: '',
        appName: '',
        remark: ''
      }
      this.$nextTick(() => {
        if (this.$refs.appFormRef) {
          this.$refs.appFormRef.clearValidate()
        }
      })
    },

    /**
     * 提交表单（新增/编辑）
     */
    submitForm() {
      // 表单校验
      this.$refs.appFormRef.validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }

        // 区分新增和编辑
        if (this.isEdit) {
          // 编辑：PUT 请求 /app/update/{id}
          this.request.put(`/api/app/update/${this.formData.id}`, this.formData).then(res => {
            if (res.code === '0' || res.code === 200) {
              this.$message.success('编辑成功')
              this.dialogVisible = false
              this.getAppList() // 刷新列表
            } else {
              this.$message.error(res.msg || res.message || '编辑失败')
            }
          }).catch(err => {
            this.$message.error('提交失败，请检查网络')
            console.error(err)
          })
        } else {
          // 新增：POST 请求 /app/add
          this.request.post("/api/app/add", this.formData).then(res => {
            if (res.code === '0' || res.code === 200) {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.getAppList() // 刷新列表
            } else {
              this.$message.error(res.msg || res.message || '新增失败，软件ID可能已存在')
            }
          }).catch(err => {
            this.$message.error('提交失败，请检查网络')
            console.error(err)
          })
        }
      })
    },

    /**
     * 删除软件
     */
    deleteApp(id) {
      if (!id) {
        this.$message.warning('无效的软件ID')
        return
      }

      // 二次确认弹窗
      this.$confirm(
        '确定要删除该软件吗？删除后关联版本也可能被删除！',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger',
          confirmButtonClass: 'el-button--danger',
          closeOnClickModal: false
        }
      ).then(() => {
        // 发送删除请求
        this.request.delete(`/api/app/delete/${id}`).then(res => {
          if (res.code === '0' || res.code === 200) {
            this.$message.success('删除成功')
            this.getAppList() // 刷新列表
          } else {
            this.$message.error(res.msg || res.message || '删除失败')
          }
        }).catch(err => {
          this.$message.error('删除失败，请检查网络')
          console.error(err)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style scoped>
/* 容器整体样式 */
.app-manager-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 100px);
}

/* 卡片样式 */
.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

/* 头部操作栏 */
.header-operation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

/* 新增按钮 */
.add-btn {
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
}

/* 表格单元格文本 */
.cell-text {
  color: #303133;
  font-size: 14px;
}

/* 弹窗表单 */
.dialog-form {
  padding: 10px 0;
}

/* 操作按钮样式 */
.edit-btn,
.delete-btn {
  border-radius: 6px;
  padding: 6px 12px;
  margin: 0 4px;
}

/* 表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

/* 弹窗圆角 */
::v-deep .el-dialog__header {
  padding: 20px 20px 16px;
}

::v-deep .el-dialog__body {
  padding: 16px 20px 20px;
}

::v-deep .el-dialog__footer {
  padding: 12px 20px 20px;
  text-align: right;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-button {
  border-radius: 8px;
}

/* 表格行悬停效果 */
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f0f9ff;
  cursor: pointer;
}
</style>